import { useNavigate } from 'react-router-dom';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { HandDrawnButton } from '../../shared/HandDrawnButton/HandDrawnButton';

import { PropertyPanelsProps } from './PropertyPanels';

type CombinePanelProps = PropertyPanelsProps & {
  main?: boolean;
};

const CombinePanel: React.FC<CombinePanelProps> = ({ property, main }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const getContentForProperty = () => {
    switch (property.toLowerCase()) {
      case 'atacama':
        return {
          background: '#7B6569',
          smallImage: "/assets/images/carrousel/carrousel-atacama-02.png",
          bigImage: "/assets/images/carrousel/carrousel-atacama-03.png"
        };
      case 'iguazu':
        return {
          background: '#3E5B58',
          smallImage: "/assets/images/carrousel/carrousel-iguazu-04.jpg",
          bigImage: "/assets/images/carrousel/carrousel-iguazu-05.jpg"
        };
      case 'mendoza':
        return {
          background: '#502630',
          smallImage: "/assets/images/carrousel/carrousel-mendoza-04.jpg",
          bigImage: "/assets/images/carrousel/carrousel-mendoza-05.jpg"
        };
      case 'santa-catarina':
      case 'santacatarina':
        return {
          background: '#009485',
          smallImage: "/assets/images/carrousel/carrousel-santa-catarina-02.jpg",
          bigImage: "/assets/images/carrousel/carrousel-santa-catarina-03.jpg"
        };
      case 'patagonia':
      default:
        return {
          background: '#C0C6C8 ',
          smallImage: "/assets/images/carrousel/carrousel-patagonia-01.jpg",
          bigImage: "/assets/images/carrousel/carrousel-patagonia-02.jpg"
        };
    }
  };

  const content = getContentForProperty();
  const showLinks = false;

  // Get property-specific content
  const getContentForPropertyMain = () => {

    switch (property.toLowerCase()) {
      case 'iguazu':
        return {
          title: t('properties/iguazu:villa.heading'),
          description: t('properties/iguazu:villa.description'),
          additionalInfo: "Built on stilts for minimal environmental impact, the 14 Villas are spread throughout the jungle, each positioned for utmost privacy but within easy distance of the main lodge. There are 13 standard Villas, and 1 Master Villa. Awasi Iguazú is the perfect place to enjoy the very best of the Misiones Province, Argentina.",
          background: 'white',
          smallImage: "/assets/images/carrousel/carrousel-iguazu-06.jpg",
          bigImage: "/assets/images/carrousel/carrousel-iguazu-07.jpg",
          lastSlideTitle: t('properties/patagonia:accommodations.lastSlide.title'),
          lastSlideDescription: t('properties/patagonia:accommodations.lastSlide.description')
        };
      case 'mendoza':
        return {
          title: t('properties/mendoza:intro.subheading'),
          description: t('properties/mendoza:intro.subdescription'),
          additionalInfo: "Immerse yourself in the heart of wine country with our collection of self-standing accommodations, each offering breathtaking views of the Andes Mountains. Ranging from intimate vineyard hideaways to expansive villas, every room is designed for privacy, space, and serenity.",
          background: 'white',
          smallImage: "/assets/images/carrousel/carrousel-mendoza-06.jpg",
          bigImage: "/assets/images/carrousel/carrousel-mendoza-07.jpg",
          lastSlideTitle: t('properties/patagonia:accommodations.lastSlide.title'),
          lastSlideDescription: t('properties/patagonia:accommodations.lastSlide.description')
        };
      case 'santa-catarina':
      case 'santacatarina':
        return {
          title: t('properties/santa-catarina:intro.mainLodge.title'),
          description: t('properties/santa-catarina:intro.mainLodge.description'),
          additionalInfo: "A natural preservation area, highlighted by the exuberance of the Atlantic Forest and small coves, creates the ideal setting for days of disconnecting from the outside world, focusing on well-being and contemplating nature. Experience tranquility and comfort in one of our 25 Villas.",
          background: 'white',
          smallImage: "/assets/images/carrousel/carrousel-santa-catarina-04.jpg",
          bigImage: "/assets/images/carrousel/carrousel-santa-catarina-05.jpg",
          lastSlideTitle: t('properties/patagonia:accommodations.lastSlide.title'),
          lastSlideDescription: t('properties/patagonia:accommodations.lastSlide.description')
        };
      case 'patagonia':
      default:
        return {
          title: t('properties/patagonia:intro.heading'),
          description: t('properties/patagonia:intro.description'),
          additionalInfo: t('properties/patagonia:intro.expandedDescription'),
          background: 'white',
          smallImage: "/assets/images/carrousel/carrousel-patagonia-04.jpg",
          bigImage: "/assets/images/carrousel/carrousel-patagonia-05.jpg",
          lastSlideTitle: t('properties/patagonia:accommodations.lastSlide.title'),
          lastSlideDescription: t('properties/patagonia:accommodations.lastSlide.description')
        };
    }
  };

  const contentMain = getContentForPropertyMain();


  return (
    <div className={`combine-panel combine-panel--${property}-type` + (main ? ' combine-panel--is-main' : '')} style={{ backgroundColor: main ? contentMain.background : content.background }}>
      <div className="combine-panel__content">
        <h2 className={`combine-panel__title ${main ? 'main' : ''}`}>
          {main
            ? contentMain.title
            : contentMain.lastSlideTitle
          }
        </h2>
        <p className={`combine-panel__description ${main ? 'main' : ''}`}>
          {main
            ? contentMain.description
            : contentMain.lastSlideDescription
          }
        </p>
        {
          showLinks &&
          <HandDrawnButton
            text="PLAN YOUR TRIP"
            variant={property as any}
            color="awasi"
            animation="stroke-to-fill"
            onClick={() => navigate('/packages/combine-lodges/')}
          />
        }
        <div className="combine-panel__small-image">
          <img src={main ? contentMain.smallImage : content.smallImage} alt={property} />
        </div>
      </div>
      <div className="combine-panel__main-image">
        <img src={main ? contentMain.bigImage : content.bigImage} alt={property} />
      </div>
    </div>
  );
};

export default CombinePanel;